// export const config = Object.freeze({
//     apiUrl: 'https://hghapi.keshonect.co.ke/',
//     Url: 'https://hghapi.keshonect.co.ke/'
// });
import React, { Component } from "react";

export class config extends Component {
  constructor(props) {
    super(props);
    const config = this.api_url+"";
  }
  render() {
    return <div></div>;
  }
}

export default config;
